import { createInstance } from "i18next";
import HttpApi from "i18next-http-backend";
import { initReactI18next } from "react-i18next";
import { fallbackLng } from "@sisuwellness/utilities/i18n/fallbackLanguage";
import { getDevConfig, getDebugMode } from "@sisuwellness/utilities/i18n/devConfig";

// SimpleLocalize configuration
const projectToken = process.env.REACT_APP_SIMPLE_LOCALIZE_PROJECT_TOKEN;
const environment = process.env.REACT_APP_SIMPLE_LOCALIZE_ENV;
const cdnBaseUrl = process.env.REACT_APP_SIMPLE_LOCALIZE_CDN;
const loadPath = `${cdnBaseUrl}/${projectToken}/${environment}/{{lng}}`;

const i18n = createInstance({
    debug: getDebugMode(process.env.REACT_APP_SIMPLE_LOCALIZE_DEBUG),
    // Unified fallback strategy from utilities (supports all project language codes)
    fallbackLng,
    load: "currentOnly",
    interpolation: {
        escapeValue: false
    },
    // Retry configuration for failed translation loads
    retryTimeout: 350, // Milliseconds between retries (exponential backoff)
    maxRetries: 5, // Maximum number of retry attempts
    backend: {
        loadPath: loadPath
    },
    returnObjects: true,
    returnEmptyString: false, // Don't return empty strings as valid translations
    // Enhanced dev config with better error messages (only in development)
    ...getDevConfig("web-components"),
    react: {
        bindI18n: "languageChanged",
        useSuspense: false
    }
});

i18n.use(HttpApi)
    .use(initReactI18next)
    .init();

export default i18n;
